import { setToken, getToken, removeToken, setAdminInfo, getAdminInfo, clearStorage } from '../../utils/storage'
export default {
  state: {
    token: getToken(),
    admin: getAdminInfo()
  },
  getters: {
    // 是否超级管理员
    isSuperAdmin(state) {
      return state.admin && state.admin.role_type === 1
    },
    // 是否业主管理员
    isOwnerAdmin(state) {
      return state.admin && state.admin.role_type === 2
    },
    // 当前管理员所属业主ID
    ownerId(state) {
      return state.admin ? state.admin.owner_id : 0
    }
  },
  mutations: {
    SET_TOKEN(state, val) {
      state.token = val
      setToken(val)
    },
    SET_ADMIN(state, val) {
      state.admin = val
      setAdminInfo(val)
    },
    LOGOUT(state) {
      state.token = ''
      state.admin = null
      clearStorage()
    }
  },
  actions: {
    login({ commit }, { token, admin }) {
      commit('SET_TOKEN', token)
      commit('SET_ADMIN', admin)
    },
    logout({ commit }) {
      commit('LOGOUT')
    }
  }
}
